












import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class ServiceCategoryTabItem extends Vue {
  @Prop({ default: false }) private active!: boolean;
}
